import React, { Component } from 'react';
import './ProgressBar.css';
import ProgressBarList from "./ProgressBarList";

class ProgressBar extends Component {
    render() {
        return (
            <div className="progressBar container-fluid">
                <ProgressBarList currentStep={this.props.currentStep}/>
            </div>
        );
    }
}

export default ProgressBar;



// WEBPACK FOOTER //
// ./src/components/header/ProgressBar.jsx